import { makeAutoObservable, action, computed } from "mobx";
import Web3 from "web3";

import { DutchAuction } from "../dutch-auction/contract";

export class Web3Store {
  private web3: Web3 | null = null;
  private contract: DutchAuction | null = null;
  private available: boolean = false;
  private syncedContract: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  setWeb3(web3: Web3) {
    this.web3 = web3;
    this.contract = new DutchAuction(this.web3);
    this.available = true;
  }

  @action
  setSyncContract(synced: boolean) {
    this.syncedContract = synced;
  }

  @computed
  getWeb3() {
    return this.web3;
  }

  @computed
  getContract() {
    return this.contract;
  }

  @computed
  isAvailable() {
    return this.available;
  }

  @computed
  getSyncedContract() {
    return this.syncedContract;
  }
}
